export default __webpack_public_path__ + "static/media/Y6.297ac74a.jpg";